import { redirect } from 'react-router-dom'

export function downloadRedirectLoader() {
  const ua = navigator.userAgent
  const isAndroid = /Android/.test(ua)
  const appleAppStoreUrl = import.meta.env.VITE_APP_URL_APPLE_APP_STORE as
    | string
    | undefined
  const googlePlayStoreUrl = import.meta.env.VITE_APP_URL_GOOGLE_PLAY_STORE as
    | string
    | undefined
  const webAppUrl = import.meta.env.VITE_APP_URL_WEB as string | undefined

  const storeUrl = isAndroid ? googlePlayStoreUrl : appleAppStoreUrl
  const url = storeUrl || webAppUrl

  if (!url) {
    return redirect('/')
  }

  return redirect(url)
}
